Sale = require './sale.coffee'

module.exports = class Auction extends Sale
  # Deprecated
